module.exports = __webpack_public_path__ + "static/media/28DGC8.e0923a6e.jpg";